// Valida CPF brasileiro pelo algoritmo dos dígitos verificadores.
// Aceita string formatada ("123.456.789-09") ou só dígitos ("12345678909").
// Retorna { valid: boolean, error?: string }.

const CPFS_INVALIDOS = new Set([
    '00000000000', '11111111111', '22222222222', '33333333333', '44444444444',
    '55555555555', '66666666666', '77777777777', '88888888888', '99999999999',
]);

export function validateCPF(input) {
    if (input == null) return { valid: false, error: 'Informe o CPF.' };

    const cpf = String(input).replace(/\D/g, '');

    if (cpf.length === 0) return { valid: false, error: 'Informe o CPF.' };
    if (cpf.length !== 11) return { valid: false, error: 'CPF deve ter 11 dígitos.' };
    if (CPFS_INVALIDOS.has(cpf)) return { valid: false, error: 'CPF inválido.' };

    // Primeiro dígito verificador
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf[i], 10) * (10 - i);
    }
    let resto = (soma * 10) % 11;
    if (resto === 10) resto = 0;
    if (resto !== parseInt(cpf[9], 10)) return { valid: false, error: 'CPF inválido.' };

    // Segundo dígito verificador
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf[i], 10) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10) resto = 0;
    if (resto !== parseInt(cpf[10], 10)) return { valid: false, error: 'CPF inválido.' };

    return { valid: true };
}

// Formata um CPF parcialmente (pra usar onChange).
export function formatCPF(input) {
    const digits = String(input || '').replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}
